var _title;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsFacilities = function SvgSettingsFacilities(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "settings-facilities")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": " ",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.56,21.31A3.72,3.72,0,0,1,23.14,25l.45,8.37a.84.84,0,0,1-.84.89H20.5a.84.84,0,0,1-.84-.89L20.11,25a3.7,3.7,0,0,1-2.42-3.68c0-1.21.54-4.36.56-4.53.12-.71,1.6-.72,1.69,0v5c0,.12.53.11.56,0,.05-.89.28-4.9.28-5,.12-.73,1.57-.73,1.69,0,0,.1.23,4.1.28,5,0,.11.52.12.56,0v-5c.09-.76,1.57-.75,1.69,0C25,17,25.56,20.11,25.56,21.31Zm5.91-5.06a.84.84,0,0,1,.84.84V33.41a.84.84,0,0,1-.84.84h-2a.84.84,0,0,1-.84-.91l.53-6.51C23.68,22.53,28.57,16.25,31.47,16.25Z",
    style: {
      fill: "#666"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsFacilities, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-facilities.dc0af9c3.svg";
export { ForwardRef as ReactComponent };